<template>
  <div class="flex flex-wrap gap-3.5">
    <UiButton
      v-for="provider in providers"
      :key="provider.id"
      variant="outlined"
      color="white"
      class="flex-[1_0_calc(33.333%-14px)] whitespace-nowrap"
      @click="onAuthByProviderId(provider.id)"
    >
      <UiIcon
        :name="provider.icon"
        class="-mt-px mr-2 size-6 flex-shrink-0"
        skip-svgo
      />
      <span>{{ $t("continueWith", { title: provider.name }) }}</span>
    </UiButton>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(["success", "failed"]);
const generalStore = useGeneralStore();

const { authByProviderId } = useAuth();

const providers = [
  { id: "google.com", name: "Google", icon: "google" },
  // { id: "facebook.com", name: "Facebook", icon: "social-logo/facebook" },
  // { id: "apple.com", name: "Apple", icon: "social-logo/apple" },
] as const;
type ProviderIds = (typeof providers)[number]["id"];

async function onAuthByProviderId(providerId: ProviderIds) {
  try {
    await authByProviderId(providerId);
    await Promise.all([generalStore.getCart(), generalStore.getWishList()]);
    emit("success");
  } catch (error) {
    emit("failed");
  }
}
</script>
